import Listing from "./listing";
import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";

const ResultsView = ({
  listings,
  options,
  buildGlobalDetailPage,
  isGlobal,
  consider,
}) => {
  let results = [];
  const [count, setCount] = useState(0);
  const width = Math.max(
    document.documentElement.clientWidth,
    window.innerWidth || 0
  );
  const [resultsValue, setResultsValue] = useState([]);
  const [resultsValueMob, setResultsValueMob] = useState([]);
  const [buttoView, setButtonView] = useState(false);
  listings.forEach((listing, index) => {
    if (index > 0 && index % 2 === 0) {
      results.push(
        <div className="clearfix until-sm" key={"clearblock" + index}></div>
      );
    }
    results.push(
      <Listing
        listing={listing}
        options={options}
        index={index}
        key={index}
        buildGlobalDetailPage={buildGlobalDetailPage}
        isGlobal={isGlobal}
      />
    );
  });
  useEffect(() => {
    let resValue = [];
    if (listings.length > 0) {
      resValue.push(
        <Listing
          listing={listings[count]}
          options={options}
          index={count}
          key={count}
          buildGlobalDetailPage={buildGlobalDetailPage}
          isGlobal={isGlobal}
        />
      );
      setResultsValueMob([resValue[0]]);
    }
    if (listings.length > 1) {
      let indexValue = count + 1 == listings.length ? 0 : count + 1;
      resValue.push(
        <Listing
          listing={listings[indexValue]}
          options={options}
          index={indexValue}
          key={indexValue}
          buildGlobalDetailPage={buildGlobalDetailPage}
          isGlobal={isGlobal}
        />
      );
      if (listings.length > 2) {
        setButtonView(true);
      } else if (width < 768) {
        setButtonView(true);
      }
    }
    setResultsValue([...resValue]);
  }, [count]);
  return consider ? (
    <div
      className="container results-view web-container"
      style={{ position: "relative" }}
    >
      {buttoView && (
        <button
          aria-label="previous slide / item"
          className="slideButton leftSlide"
          onClick={(e) => {
            if (count - 1 < 0) {
              setCount(listings.length - 1);
            } else {
              setCount(count - 1);
            }
          }}
        ></button>
      )}
      <div className="row">
        <div className={`desktopview`}>{resultsValue}</div>
        <div className="mobileview">{resultsValueMob}</div>
      </div>
      {buttoView && (
        <button
          aria-label="next slide / item"
          className="slideButton rightSlide"
          onClick={(e) => {
            if (count + 1 > listings.length - 1) {
              setCount(0);
            } else {
              setCount(count + 1);
            }
          }}
        ></button>
      )}
    </div>
  ) : (
    <div className="container results-view web-container">
      <div className="row">{results}</div>
    </div>
  );
};

ResultsView.propTypes = {
  listings: PropTypes.array.isRequired,
  options: PropTypes.object.isRequired,
};

export default ResultsView;



// WEBPACK FOOTER //
// ./src/components/homepage/featured/results-view.js